import { render, staticRenderFns } from "./BaseBreadcrumb.vue?vue&type=template&id=e6681062&scoped=true"
import script from "./BaseBreadcrumb.vue?vue&type=script&lang=js"
export * from "./BaseBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6681062",
  null
  
)

export default component.exports